module.exports = __webpack_public_path__ + "img/search-default.7dcbc52f.svg";